import type { TemplatePackRead } from '../../types/api';

/**
 * What a pack is *for*, in the user's words — the axis the gallery filters on.
 * Derived from the pack's own contract rather than stored: a pack whose items
 * carry headshots is about people whatever its slug says.
 */
export type PackIntent = 'people' | 'products' | 'menu' | 'offers';

export function packIntent(pack: TemplatePackRead): PackIntent {
  if (pack.layout === 'menu_list') return 'menu';
  if (pack.layout === 'offer') return 'offers';
  if (pack.fields.image_role === 'product') return 'products';
  return 'people';
}
